import { JsonObject, JsonProperty } from "ta-json";

@JsonObject()
export class MetricOptionResponseResource {
    @JsonProperty("type")
    type: string;

    @JsonProperty("field")
    field: number;

    @JsonProperty("value")
    value: number;
}
